<template>
  <div id="paginaContributiSponsorship">
    <!-- Elementi Pagina----------------------------------------------------------------------------------- -->
    <b-row class="match-height">
      <b-col xl="12" md="12">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Elenco Contributi & Sponsor</b-card-title>
              <b-card-text class="mb-0"> Teatro Coccia </b-card-text>
            </div>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>
              <b-col xl="12" md="12" class="pt-1">
                <ejs-dropdownlist id="dropAnniRiferimento" ref="dropAnniRiferimento" :query="queryAnno"
                  :dataSource="annoRiferimentoList" :index="annoIndex" :fields="annoRiferimentoFields"
                  :change="onAnnoRiferimentoChange" v-model="annoRiferimentoCorrente"
                  placeholder="Seleziona un Anno"></ejs-dropdownlist>
              </b-col>
              <!-- Timer Alert -->
              <b-col xl="6" md="12">
                <b-alert :show="alertADismissCountDown" dismissible variant="warning"
                  @dismissed="alertADismissCountDown = 0" @dismiss-count-down="alertACountDownChanged">
                  <p>Occorre selezionare una riga della tabella</p>
                  <b-alert variant="warning" :max="alertADismissSecs" :value="alertADismissCountDown" height="4px" />
                </b-alert>
              </b-col>

              <b-col xl="12" md="12" class="pt-1">
                <div id="GridParent">
                  <ejs-grid id="gridA" ref="gridA" :dataSource="contributiFullData" :allowSorting="true"
                    :sortSettings="gridA.sortOptions" :toolbarClick="gridAClickHandler" :toolbar="gridA.toolbarOptions"
                    :height="gridA.height" :allowFiltering="true" :filterSettings="gridA.filterOptions"
                    :editSettings="gridA.editOptions">
                    <e-columns>
                      <e-column field="id" headerText="ID" :isPrimaryKey="true" width="100"></e-column>
                      <!-- <e-column field="data" headerText="Data" :format="settings.formatoData" type="date"
                        width="200"></e-column> -->
                      <e-column field="tipologia" headerText="Tipologia" width="200"></e-column>
                      <e-column field="soggettoErogatore" headerText="Soggetto Erogatore" width="200"></e-column>
                      <e-column field="dataAssegnazione" headerText="Data Assegnazione" :format="settings.formatoData"
                        type="date" width="200"></e-column>
                      <e-column field="importoAssegnato" headerText="Importo Assegnato" width="200"></e-column>
                      <e-column field="dataPrevIncasso" headerText="Data Prev. Incasso" :format="settings.formatoData"
                        type="date" width="200"></e-column>
                      <e-column field="assegnato" headerText="Assegnato" displayAsCheckBox='true' width="200"></e-column>
                      <e-column field="incassato" headerText="Incassato" displayAsCheckBox='true' width="200"></e-column>
                      <e-column field="note" headerText="Note" width="300"></e-column>
                      <e-column field="spettacolo" width="50" :visible="false"></e-column>
                    </e-columns>
                  </ejs-grid>
                </div>
              </b-col>

              <b-col xl="12" md="12" class="mt-3">
                <h3>Riepilogo Contributi e Sponsor</h3>
              </b-col>
              <b-col xl="6" md="6" class="mt-1">
                <ejs-button id="aggiornaRiepilogoButton" @click.native="aggiornaRiepilogo()">Aggiorna Riepilogo</ejs-button>
              </b-col>
              <b-col xl="6" md="6" class="mt-1">
                <ejs-button id="downloadXlsButton" @click.native="downloadXls()">Download XLS</ejs-button>
              </b-col>

              <b-col v-for="cat in categorieConTotali" :key="cat.key" xl="12" md="12" class="mt-0">
                <b-card tag="article" class="mb-0">
                  <b-card-header class="align-items-baseline">
                    <div>
                      <b-card-title>{{ cat.titolo }}</b-card-title>
                      <b-card-text class="mb-0" />
                    </div>
                  </b-card-header>
                  <b-card-body class="mb-0 pb-0">
                    <b-row>
                      <b-col xl="2" md="2" class="mb-0">
                        <label class="h5">Totale Preventivo</label>
                        <ejs-numerictextbox :value="cat.preventivo" floatLabelType="Never" cssClass=""
                          format="€ ###.##" placeholder="Preventivo" showSpinButton="false"
                          showClearButton="true" :readonly="true" />
                      </b-col>
                      <b-col xl="2" md="2" class="mb-0">
                        <label class="h5">Totale Cons. Incass.</label>
                        <ejs-numerictextbox :value="cat.consuntivoIncassato" floatLabelType="Never" cssClass=""
                          format="€ ###.##" placeholder="Consuntivo" showSpinButton="false"
                          showClearButton="true" :readonly="true" />
                      </b-col>
                      <b-col xl="2" md="2" class="mb-0">
                        <label class="h5">Scostamento</label>
                        <ejs-numerictextbox :value="cat.scostamento" floatLabelType="Never" cssClass=""
                          format="€ ###.##" placeholder="Prev - Cons" showSpinButton="false"
                          showClearButton="true" :readonly="true" />
                      </b-col>
                      <b-col xl="2" md="2" class="mb-0">
                        <label class="h5">Raggiungimento %</label>
                        <ejs-numerictextbox :value="cat.raggiungimentoPerc" floatLabelType="Never" cssClass=""
                          format="###.##" placeholder="Raggiungimento %" showSpinButton="false"
                          showClearButton="true" :readonly="true" />
                      </b-col>
                      <b-col xl="2" md="2" class="mb-0">
                        <label class="h5">Totale Consuntivo Assegnato</label>
                        <ejs-numerictextbox :value="cat.consuntivoAssegnato" floatLabelType="Never" cssClass=""
                          format="€ ###.##" placeholder="Consuntivo Assegnato" showSpinButton="false"
                          showClearButton="true" :readonly="true" />
                      </b-col>
                      <b-col xl="2" md="2" class="mb-0">
                        <label class="h5">Totale Consuntivo Da Incassare</label>
                        <ejs-numerictextbox :value="cat.daIncassare" floatLabelType="Never" cssClass=""
                          format="€ ###.##" placeholder="Consuntivo Da Incassare" showSpinButton="false"
                          showClearButton="true" :readonly="true" />
                      </b-col>
                    </b-row>
                  </b-card-body>
                </b-card>
              </b-col>

            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!-- dialogA: dialogDettaglioContributo ---------------------------------------------------------------------------------------------------- -->
    <ejs-dialog id="dialogA" ref="dialogA" :header="dialogA.header" :buttons="dialogA.buttons"
      :visible="dialogA.visible" :showCloseIcon="dialogA.showCloseIcon" :close="dialogAClose" :open="dialogAOpen"
      :zIndex="dialogA.zIndex" :animationSettings="dialogA.animationSettings" :isModal="dialogA.isModal">
      <!-- Content dialog -->
      <b-tabs ref="tabAdialogA" v-model="dialogA.tabAdialogAIndex">
        <b-tab title="Dati Contributo">
          <b-row class="match-height">
            <b-col xl="12" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Dati Contributo</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="id" class="h5">Id</label>
                      <ejs-textbox id="id" v-model="contributiActiveData.id" floatLabelType="Never" cssClass=""
                        placeholder="id" showClearButton="true" type="text" autocomplete="false" :readonly="true" />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="tipologia" class="h5">Tipologia</label>
                      <ejs-dropdownlist id="tipologia" ref="tipologia" :query="queryAnno" :dataSource="tipologiaList"
                        :fields="tipologiaFields" v-model="contributiActiveData.tipologia"
                        placeholder="Seleziona una tipologia"></ejs-dropdownlist>
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2 align-items-center">
                      <b-row class="m-0">
                        <label for="sponsorGenerico" class="h5 mr-1">Sponsor Stagione</label>
                        <ejs-checkbox id="sponsorGenerico" v-model="contributiActiveData.sponsorGenerico"
                          :checked="contributiActiveData.sponsorGenerico" name="sponsorGenerico" />
                      </b-row>
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="annoSpettacolo" class="h5">Anno Spettacolo</label>
                      <ejs-dropdownlist id="annoSpettacolo" ref="annoSpettacolo" :query="queryAnno"
                        :dataSource="annoSpettacoloList" :fields="annoSpettacoloFields" :change="onAnnoSpettacoloChange"
                        v-model="contributiActiveData.annoSpettacolo"
                        placeholder="Seleziona un Anno"></ejs-dropdownlist>
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="dropSpettacoli" class="h5">Spettacolo</label>
                      <ejs-dropdownlist id="dropSpettacoli" ref="dropSpettacoli" :query="querySpettacoli"
                        :dataSource="spettacoliFullData" :index="spettacoliIndex" :fields="elencoSpettacoliFields"
                        v-model="contributiActiveData.spettacolo" placeholder="Seleziona uno Spettacolo"
                        :allowFiltering="true" :filtering="spettacoloFiltering"></ejs-dropdownlist>
                    </b-col>

                    <!-- Sostituirà soggetto Erogatore testuale: capire come gestire che i soggetti possono essere sia persone fisiche che giuridiche -->
                    <b-col xl="12" md="12" class="mb-2" v-show="false">
                      <label for="fornitore" class="h5">Soggetto Erogatore</label>
                      <ejs-dropdownlist id="fornitore" ref="fornitore" v-model="contributiActiveData.fornitore"
                        :dataSource="fornitoriList" :fields="fornitoriFields" :allowFiltering="true"
                        :filtering="fornitoriFiltering" :itemTemplate="itemTemplate" :valueTemplate="valueTemplate"
                        placeholder="Scegli fornitore" />
                    </b-col>

                    <!-- Temporaneo: Capire come gestire che i soggetti possono essere sia persone fisiche che giuridiche -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="soggettoErogatore" class="h5">Soggetto Erogatore</label>
                      <ejs-textbox id="soggettoErogatore" v-model="contributiActiveData.soggettoErogatore"
                        placeholder="soggettoErogatore" floatLabelType="Never" cssClass="" showClearButton="true"
                        type="text" autocomplete="false" />
                    </b-col>

                    <!-- Input di tipo checkbox: contributiActiveData.assegnato -->
                    <b-col xl="12" md="12" class="mb-2 align-items-center">
                      <b-row class="m-0">
                        <label for="assegnato" class="h5 mr-1">Assegnato</label>
                        <ejs-checkbox id="assegnato" v-model="contributiActiveData.assegnato"
                          :checked="contributiActiveData.assegnato" name="assegnato" />
                      </b-row>
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="data" class="h5">Data di assegnazione</label>
                      <ejs-datepicker id="dataAssegnazione" v-model="contributiActiveData.dataAssegnazione"
                        :format="settings.formatoDatepicker" placeholder="Data di Assegnazione"
                        :firstDayOfWeek="settings.firstDayOfWeek" />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="importoAssegnato" class="h5">Importo totale Assegnato</label>
                      <ejs-numerictextbox id="importoAssegnato" v-model="contributiActiveData.importoAssegnato"
                        format="€ ###.##" floatLabelType="Never" cssClass="" placeholder="Importo Assegnato"
                        showSpinButton="false" showClearButton="true" />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="importoIncassato" class="h5">Importo Incassato</label>
                      <ejs-numerictextbox id="importoIncassato" v-model="contributiActiveData.importoIncassato"
                        format="€ ###.##" floatLabelType="Never" cssClass="" placeholder="Importo Incassato"
                        showSpinButton="false" showClearButton="true" />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="importoDaIncassare" class="h5">Importo da Incassare</label>
                      <ejs-numerictextbox id="importoDaIncassare" v-model="importoDaIncassare" format="€ ###.##"
                        floatLabelType="Never" cssClass="" placeholder="Importo Da Incassare" :showSpinButton="false"
                        showClearButton="true" readonly="true" />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="data" class="h5">Data prevista di incasso</label>
                      <ejs-datepicker id="dataPrevIncasso" v-model="contributiActiveData.dataPrevIncasso"
                        :format="settings.formatoDatepicker" placeholder="Data Prevista di Incasso"
                        :firstDayOfWeek="settings.firstDayOfWeek" />
                    </b-col>

                    <!-- Input di tipo checkbox: contributiActiveData.incassato -->
                    <b-col xl="12" md="12" class="mb-2 align-items-center">
                      <b-row class="m-0">
                        <label for="incassato" class="h5 mr-1">Incassato</label>
                        <ejs-checkbox id="incassato" v-model="contributiActiveData.incassato"
                          :checked="contributiActiveData.incassato" name="incassato" />
                      </b-row>
                    </b-col>

                    <!-- Input di tipo testo multilinea: contributiActiveData.note  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="note" class="h5">Note</label>
                      <ejs-textbox id="note" v-model="contributiActiveData.note" floatLabelType="Never" cssClass=""
                                   placeholder="Note" showClearButton="true" type="text" autocomplete="false"
                                   :multiline="true" :rows="3" />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2 align-items-center">
                      <b-row class="m-0">
                        <label for="fatturaEmessa" class="h5 mr-1">Fattura Emessa</label>
                        <ejs-checkbox id="fatturaEmessa" v-model="contributiActiveData.fatturaEmessa"
                                      :checked="contributiActiveData.fatturaEmessa" name="fatturaEmessa" />
                      </b-row>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </ejs-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import useJwt from '@/auth/jwt/useJwt'
// import bootstrap-Vue
import {
  LayoutPlugin,
  TabsPlugin,
  CardPlugin,
  DropdownPlugin,
  ImagePlugin,
  LinkPlugin,
  AlertPlugin,
  ToastPlugin,
} from 'bootstrap-vue'
// import Vuexy

// import Syncfusion
import { enableRipple } from '@syncfusion/ej2-base'
import { Query } from '@syncfusion/ej2-data'
import {
  DateTimePickerPlugin,
  DateRangePickerPlugin,
  DatePickerPlugin,
  TimePickerPlugin,
} from '@syncfusion/ej2-vue-calendars'
import {
  ButtonPlugin,
  CheckBoxPlugin,
  SwitchPlugin,
} from '@syncfusion/ej2-vue-buttons'
import {
  TextBoxPlugin,
  NumericTextBoxPlugin,
  MaskedTextBoxPlugin,
  UploaderPlugin,
} from '@syncfusion/ej2-vue-inputs'
import {
  DropDownListPlugin,
  MultiSelectPlugin,
  CheckBoxSelection,
} from '@syncfusion/ej2-vue-dropdowns'
import { DialogPlugin } from '@syncfusion/ej2-vue-popups'
import {
  GridPlugin,
  ForeignKey,
  Edit as GridEdit,
  Toolbar as GridToolbar,
  Sort as GridSort,
  Filter as GridFilter,
} from '@syncfusion/ej2-vue-grids'
import { DropDownButtonPlugin } from '@syncfusion/ej2-vue-splitbuttons'

const axios = require('axios')
// use bootstrap-vue
Vue.use(TabsPlugin)
Vue.use(CardPlugin)
Vue.use(LayoutPlugin)
Vue.use(DropdownPlugin)
Vue.use(ImagePlugin)
Vue.use(LinkPlugin)
Vue.use(AlertPlugin)
Vue.use(ToastPlugin)
// use Syncfusion
Vue.use(TextBoxPlugin)
Vue.use(NumericTextBoxPlugin)
Vue.use(MaskedTextBoxPlugin)
Vue.use(UploaderPlugin)
Vue.use(DateRangePickerPlugin)
Vue.use(DatePickerPlugin)
Vue.use(DateTimePickerPlugin)
Vue.use(TimePickerPlugin)
Vue.use(DropDownListPlugin)
Vue.use(MultiSelectPlugin)
Vue.use(ButtonPlugin)
Vue.use(CheckBoxPlugin)
Vue.use(SwitchPlugin)
Vue.use(DialogPlugin)
Vue.use(GridPlugin)
Vue.use(DropDownButtonPlugin)
enableRipple(true)
// api

const apiContributiSponsorshipUrl = '/demo/api/contributosponsorship'
const apiContributiSponsorshipAnnoUrl = '/demo/api/contributosponsorship/anno'
const apiContributiExportXlsUrl = '/demo/api/contributosponsorship/export_xls'

const apiFornitoriUrl = '/demo/api/soggetto/fornitori'
const apiSpettacoliRicercaUrl = '/demo/api/spettacolo/ricerca'
const apiBilancioCocciaRicercaAnnoUrl = '/demo/api/bilanciococcia/ricercaAnno'

const itemVue = Vue.component('itemTemplate', {
  data() {
    return {
      data: {},
    }
  },
  template: '<span><span class=\'ragioneSociale\'>{{data.ragioneSociale}}</span><span style=\'margin-right:3em;display:inline-block;\'>&nbsp;&nbsp;</span><span class =\'partitaIva\'>{{data.partitaIva}}</span></span>',
})

export default Vue.extend({
  components: {},
  data() {
    return {
      dataOggi: new Date(),
      // tmp
      nonMostrare: false, // utile per non cancellare codice in editing
      // generali
      settings: {
        formatoData: { type: 'date', format: 'dd-MM-yyyy' }, // da usare per grid
        formatoOra: { skeleton: 'Hm' },
        // formatoOra: 'HH:mm',
        formatoOraGrid: { type: 'dateTime', format: 'HH:mm' }, // da usare per grid
        formatoDatepicker: 'dd-MM-yyyy', // da usare per i datepicker
        intervalloOra: 5,
        firstDayOfWeek: 1,
      },
      contributiFullData: [],
      contributiActiveId: 0,
      contributiActiveData: {},
      id_spettacolo: 0,

      categorie: [
        {
          key: 'totale', titolo: 'Totale Contributi', preventivo: 0, consuntivoIncassato: 0, consuntivoAssegnato: 0,
        },
        {
          key: 'enti', titolo: 'Totale Contributi Enti e Fondazioni Bancarie', preventivo: 0, consuntivoIncassato: 0, consuntivoAssegnato: 0,
        },
        {
          key: 'sponsor', titolo: 'Totale Contributi Sponsor', preventivo: 0, consuntivoIncassato: 0, consuntivoAssegnato: 0,
        },
        {
          key: 'art', titolo: 'Totale ArtBonus', preventivo: 0, consuntivoIncassato: 0, consuntivoAssegnato: 0,
        },
        {
          key: 'privati', titolo: 'Totale Contributi Privati ed Erogazioni Liberali', preventivo: 0, consuntivoIncassato: 0, consuntivoAssegnato: 0,
        },
        {
          key: 'sponsorCantelli', titolo: 'Totale Sponsor Premio Cantelli', preventivo: 0, consuntivoIncassato: 0, consuntivoAssegnato: 0,
        },
        {
          key: 'artCantelli', titolo: 'Totale Art Bonus Premio Cantelli', preventivo: 0, consuntivoIncassato: 0, consuntivoAssegnato: 0,
        },
        {
          key: 'privatiCantelli', titolo: 'Totale Contributi Privati / Erogazioni Liberali Premio Cantelli', preventivo: 0, consuntivoIncassato: 0, consuntivoAssegnato: 0,
        },
      ],

      // per inizializzazione dropdown a null
      initIndex: -1,
      // fornitori
      fornitoriList: [],
      fornitoriFields: { text: 'ragioneSociale', value: 'id' },
      // spettacoli
      spettacoliFullData: [],
      elencoSpettacoliFields: { value: 'id', text: 'titolo' },
      spettacoliIndex: -1,
      // tipo pagamento
      tipoList: [
        { label: 'Bonifico', val: 'bonifico' },
        { label: 'Emolumento', val: 'emolumento' },
      ],
      tipoFields: { text: 'label', value: 'val' },

      itemTemplate() {
        return { template: itemVue }
      },
      valueTemplate() {
        return { template: itemVue }
      },

      annoRiferimentoList: [
        { label: 'Anno 2022', val: '2022' },
        { label: 'Anno 2023', val: '2023' },
        { label: 'Anno 2024', val: '2024' },
        { label: 'Anno 2025', val: '2025' },
        { label: 'Anno 2026', val: '2026' },
      ],
      annoRiferimentoFields: { value: 'val', text: 'label' },
      annoIndex: -1,
      queryAnno: null,
      querySpettacoli: null,
      annoRiferimentoCorrente: null,
      annoSpettacoloList: [
        { label: '2022', val: '2022' },
        { label: '2023', val: '2023' },
        { label: '2024', val: '2024' },
        { label: '2025', val: '2025' },
        { label: '2026', val: '2026' },
      ],
      annoSpettacoloFields: { value: 'val', text: 'label' },
      tipologiaList: [
        { label: 'Sponsorship', val: 'Sponsorship' },
        { label: 'Contributi da Privati', val: 'Contributi da Privati' },
        { label: 'Contributi Enti e Fondazioni Bancarie', val: 'contributi_enti_fondazioni' },
        { label: 'Art Bonus', val: 'Art Bonus' },
        { label: 'Sponsor Cantelli', val: 'Sponsor Cantelli' },
        { label: 'Art Bonus Cantelli', val: 'Art Bonus Cantelli' },
        { label: 'Contributi Cantelli da privati / erogazioni liberali', val: 'Contributi Cantelli' },
        { label: 'Sponsor AMO', val: 'Sponsor AMO' },
        { label: 'Art Bonus AMO', val: 'Art Bonus AMO' },
        { label: 'Contributi AMO da privati / erogazioni liberali', val: 'Contributi AMO' },
      ],
      tipologiaFields: { value: 'val', text: 'label' },
      // per alertA
      alertADismissSecs: 3,
      alertADismissCountDown: 0,

      // per dialogA
      dialogA: {
        header: '',
        visible: false,
        showCloseIcon: true,
        buttons: [
          {
            click: this.dialogAOk,
            buttonModel: { content: 'OK', isPrimary: true },
          },
          { click: this.dialogACancel, buttonModel: { content: 'Cancel' } },
        ],
        animationSettings: { effect: 'FadeZoom', duration: 400, delay: 0 }, // { effect: 'None' }, // selezionata per primo livello
        zIndex: 1050,
        tabAdialogAIndex: 0,
        isModal: false,
      },
      // per gridA
      gridAFlag: false,
      gridA: {
        height: 300,
        editOptions: {
          allowEditing: false,
          allowDeleting: true,
        },
        filterOptions: { type: 'Excel' },
        toolbarOptions: [
          {
            text: 'Nuovo',
            tooltipText: 'Crea nuovo contributo',
            prefixIcon: 'e-plus',
            id: 'new',
          },
          {
            text: 'Modifica',
            tooltipText: 'Modifica contributo',
            prefixIcon: 'e-expand',
            id: 'edit',
          },
          {
            text: 'Cancella',
            tooltipText: 'Cancella contributo',
            prefixIcon: 'e-cancel',
            id: 'delete',
          },
          'Search',
        ],
        sortOptions: { columns: [{ field: 'data', direction: 'Ascending' }] },
      },
    }
  },
  computed: {

    importoDaIncassare: {
      get() {
        // se il contributo è segnato come incassato non resta nulla da incassare
        if (this.contributiActiveData.incassato) return 0
        return this.contributiActiveData.importoAssegnato - this.contributiActiveData.importoIncassato
      },
      set() {},
    },
    categorieConTotali() {
      return this.categorie.map(c => ({
        ...c,
        scostamento: c.preventivo - c.consuntivoIncassato,
        daIncassare: c.consuntivoAssegnato - c.consuntivoIncassato,
        raggiungimentoPerc: (c.preventivo > 0 && c.consuntivoIncassato > 0)
          ? 100 * c.consuntivoIncassato / c.preventivo
          : null,
      }))
    },
  },
  created() {
    console.log('Pagina Contributi e Sponsorship Creata')
    // inizializzazione elenchi dal backend
    // chiamate API

    if (localStorage.getItem('userData') !== null) {
      console.log('Recupero elenco Contributi dal backend')
      // fornitori
      useJwt.get(apiFornitoriUrl).then(d => {
        if (d.status != 200) {
          console.log('REDIRIGERE A LOGIN')
          alert('Effettua di nuovo il login')
        } else {
          // console.log(d.status);
          // console.log(d.data);
          this.fornitoriList = d.data
        }
      })
    } else {
      console.log('Non trovo UserData, prova ancora')
    }
  },

  mounted() {
    // disabilito gridA
    this.$refs.gridA.$el.classList.add('disablegrid')
    document.getElementById('GridParent').classList.add('wrapper')
    // focus su dropAnniRiferimento
    this.$refs.dropAnniRiferimento.ej2Instances.focusIn()
  },

  provide: {
    // per grid
    grid: [GridToolbar, GridSort, GridFilter, GridEdit, ForeignKey],
    // per multiselect
    multiselect: [CheckBoxSelection],
  },
  methods: {
    fornitoriFiltering(e) {
      const searchData = this.fornitoriList
      let query = new Query()
      query = e.text != '' ? query.where('ragioneSociale', 'contains', e.text, true) : query
      e.updateData(searchData, query)
    },
    spettacoloFiltering(e) {
      const searchData = this.spettacoliFullData
      let query = new Query()
      query = e.text != '' ? query.where('titolo', 'contains', e.text, true) : query
      e.updateData(searchData, query)
    },
    onAnnoRiferimentoChange(e) {
      console.log('Change')
      console.log("Recupero elenco contributi per l'anno selezionato")
      const datiDaInviare = { anno: this.annoRiferimentoCorrente }
      useJwt.post(apiContributiSponsorshipAnnoUrl, datiDaInviare).then(d => {
        console.log('Contributi')
        console.log(d.data)
        this.contributiFullData = d.data
        this.$refs.gridA.$el.classList.remove('disablegrid')
        document.getElementById('GridParent').classList.remove('wrapper')
      })
      // Azzero i totali
      this.categorie.forEach(c => {
        c.preventivo = 0
        c.consuntivoIncassato = 0
        c.consuntivoAssegnato = 0
      })
    },
    onAnnoSpettacoloChange(e) {
      console.log('Change Anno Spettacolo')
      const stagioneSpettacolo = { stagione: this.contributiActiveData.annoSpettacolo }
      useJwt.post(apiSpettacoliRicercaUrl, stagioneSpettacolo).then(d => {
        console.log('SPETTACOLI')
        console.log(d.data)
        this.spettacoliFullData = d.data
      })
    },

    downloadXls() {
      const datiDaInviare = { anno: this.annoRiferimentoCorrente }
      useJwt.post(apiContributiExportXlsUrl, datiDaInviare, { responseType: 'blob' }).then(r => {
        const fileName = r.headers['content-disposition'].split('filename=')[1]
        const url = window.URL.createObjectURL(new Blob([r.data]))
        const link = document.createElement('a')
        link.href = url

        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
      }).catch(r => {
        this.makeToast('primary', 'FAILURE', 'Errore stagione non selezionata')
      })
    },

    async aggiornaRiepilogo() {
      console.log('Aggiorna Riepilogo')

      const cat = key => this.categorie.find(c => c.key === key)

      // reset preventivi
      this.categorie.forEach(c => { c.preventivo = 0 })

      // lettura preventivi dal bilancio
      const r = await useJwt.post(apiBilancioCocciaRicercaAnnoUrl, { anno: this.annoRiferimentoCorrente }).then(d => {
        if (d.data.error == false) {
          cat('totale').preventivo = (
            +d.data.prevContributiEntiFondazioni
            + +d.data.prevRicaviSponsor
            + +d.data.prevContrArtBonus
            + +d.data.prevContributiErogazioniLiberali
            + +d.data.prevRicaviSponsorCantelli
            + +d.data.prevArtBonusCantelli
            + +d.data.prevContribErogazioniLiberaliCantelli
          )
          cat('enti').preventivo = +d.data.prevContributiEntiFondazioni
          cat('sponsor').preventivo = +d.data.prevRicaviSponsor
          cat('art').preventivo = +d.data.prevContrArtBonus
          cat('privati').preventivo = +d.data.prevContributiErogazioniLiberali
          cat('sponsorCantelli').preventivo = +d.data.prevRicaviSponsorCantelli
          cat('artCantelli').preventivo = +d.data.prevArtBonusCantelli
          cat('privatiCantelli').preventivo = +d.data.prevContribErogazioniLiberaliCantelli
          return false
        }
        return true
      })

      if (r) {
        this.makeToast('primary', 'Attenzione', "Bilancio mancante per l'anno selezionato")
      }

      // reset consuntivi e calcolo dal dettaglio
      this.categorie.forEach(c => { c.consuntivoIncassato = 0; c.consuntivoAssegnato = 0 })
      const tipologieSponsor = ['Sponsorship', 'Sponsor AMO']
      const tipologieArtBonus = ['Art Bonus', 'Art Bonus AMO']
      const tipologieArtBonusCantelli = ['Art Bonus Cantelli']
      const tipologiePrivati = ['Contributi da Privati', 'Contributi AMO']
      const tipologieSponsorCantelli = ['Sponsor Cantelli']
      const tipologieEnti = ['contributi_enti_fondazioni']
      const tipologieContribCantelli = ['Contributi Cantelli']
      
      this.contributiFullData.forEach(obj => {
        const incassato = Number(obj.importoIncassato)
        const assegnato = Number(obj.importoAssegnato)
        cat('totale').consuntivoIncassato += incassato
        cat('totale').consuntivoAssegnato += assegnato
        if (tipologieSponsor.includes(obj.tipologia)) {
          cat('sponsor').consuntivoIncassato += incassato
          cat('sponsor').consuntivoAssegnato += assegnato
        }
        if (tipologieArtBonus.includes(obj.tipologia)) {
          cat('art').consuntivoIncassato += incassato
          cat('art').consuntivoAssegnato += assegnato
        }
        if (tipologiePrivati.includes(obj.tipologia)) {
          cat('privati').consuntivoIncassato += incassato
          cat('privati').consuntivoAssegnato += assegnato
        }
        if (tipologieSponsorCantelli.includes(obj.tipologia)) {
          cat('sponsorCantelli').consuntivoIncassato += incassato
          cat('sponsorCantelli').consuntivoAssegnato += assegnato
        }
        if (tipologieContribCantelli.includes(obj.tipologia)) {
          cat('privatiCantelli').consuntivoIncassato += incassato
          cat('privatiCantelli').consuntivoAssegnato += assegnato
        }
        if (tipologieEnti.includes(obj.tipologia)) {
          cat('enti').consuntivoIncassato += incassato
          cat('enti').consuntivoAssegnato += assegnato
        }
        if (tipologieArtBonusCantelli.includes(obj.tipologia)) {
          cat('artCantelli').consuntivoIncassato += incassato
          cat('artCantelli').consuntivoAssegnato += assegnato
        }
      })
    },

    // per dialogA
    dialogAOpen(args) {
      console.log('Apertura dialogA')

      this.contributiActiveData.spettacolo = this.id_spettacolo
      // evita chiusura dialog su pressione enter
      const dialogObj = args.element.ej2_instances[0]
      dialogObj.keyDown = this.noop.bind(this)
      dialogObj.dataBind()
    },
    dialogAClose() {
      console.log('Chiusura dialogA')
      this.dialogA.tabAdialogAIndex = 0
      // console.log(this.contributiActiveData);
    },
    dialogAOk() {
      console.log('Cliccato bottone OK di dialogA')
      // memorizzo importoTotale
      this.contributiActiveData.importoDaIncassare = this.importoDaIncassare
      // salvataggio informazioni in remoto
      const nuovo = this.contributiActiveId === 0
      const richiesta = nuovo
        ? useJwt.post(apiContributiSponsorshipUrl, this.contributiActiveData)
        : useJwt.patch(`${apiContributiSponsorshipUrl}/${this.contributiActiveId}`, this.contributiActiveData)
      richiesta
        .then(res => {
          if (nuovo) {
            console.log('CONTRIBUTO CREATO')
            console.log(res.data)
            // mi segno ID elemento appena creato
            this.contributiActiveId = res.data.id
          }
          this.makeToast(
            'primary',
            'Successo',
            nuovo ? 'Creazione del contributo' : 'Modifica del contributo sponsorship',
          )
          // chiudo il dialog solo a salvataggio avvenuto, così in caso di errore i dati inseriti non vanno persi
          this.$refs.dialogA.hide()
          // aggiornamento gridA
          const datiDaInviare = {
            anno: this.annoRiferimentoCorrente,
          }
          return useJwt.post(apiContributiSponsorshipAnnoUrl, datiDaInviare).then(r => {
            console.log('Aggiornamento gridA dopo salvataggio contributo sponsorship')
            this.contributiFullData = [...r.data]
          })
        })
        .catch(err => {
          console.log(err)
          this.makeToast('danger', 'Errore', 'Salvataggio del contributo non riuscito')
        })
      // triggerare aggiornamento filtering / ordinamento? <----------------------
    },
    dialogACancel() {
      console.log('Cliccato bottone Cancel di dialogA')
      this.$refs.dialogA.hide()
    },
    // per gridA
    gridAClickHandler(args) {
      // pulsante NEW
      if (args.item.id === 'new') {
        this.dialogA.header = 'Nuovo Contributo'
        const oggi = new Date()
        this.contributiDefaultData = {
          id: 0,
          anno: this.annoRiferimentoCorrente,
          tipologia: null,
          annoSpettacolo: null,
          spettacolo: 0,
          soggettoErogatore: null,
          dataAssegnazione: null,
          importo: null,
          dataPrevIncasso: null,
          assegnato: false,
          incassato: false,
          note: null,
          sponsorGenerico: false,
          importoAssegnato: 0,
          importoIncassato: 0,
          importoDaIncassare: 0,
          fatturaEmessa: false,
        }
        this.contributiActiveData = this.contributiDefaultData
        // azzero lo spettacolo eventualmente memorizzato da un edit precedente:
        // dialogAOpen lo riassegna a contributiActiveData.spettacolo
        this.id_spettacolo = 0
        console.log('Premuto pulsante creazione nuovo contributo da gridA')
        // console.log(this.contributiActiveData);
        this.contributiActiveId = 0
        this.$refs.dialogA.show(true)
      } else if (args.item.id === 'edit') {
        console.log('Premuto pulsante modifica contributo da gridA')
        try {
          const selectedRow = this.$refs.gridA.getSelectedRecords()
          this.contributiActiveId = selectedRow[0].id
          console.log('gridA, Id selezionato:')
          console.log(this.contributiActiveId)
          const i = this.contributiFullData.findIndex(
            x => x.id === this.contributiActiveId,
          )
          if (i >= 0) {
            console.log('id spettacolo')
            this.id_spettacolo = this.contributiFullData[i].spettacolo
            console.log(this.id_spettacolo)
            // copia: le modifiche nel dialog non devono toccare la riga della grid finché non si preme OK
            this.contributiActiveData = { ...this.contributiFullData[i] }
            console.log('contributi active data on edit')
            console.log(this.contributiActiveData)
          }
          this.$refs.dialogA.show(true)
        } catch (err) {
          console.log('Occorre selezionare una riga della tabella')
          console.log(err)
          this.alertAShow()
        }
      } else if (args.item.id === 'delete') {
        try {
          console.log('Premuto pulsante elimina contributo da gridA')
          const selectedRow = this.$refs.gridA.getSelectedRecords()
          const deletedElementId = selectedRow[0].id

          const deleteUrl = `${apiContributiSponsorshipUrl}/${deletedElementId}`

          this.$bvModal.msgBoxConfirm(`Eliminare il contributo ${deletedElementId}?`, {
            title: 'Conferma eliminazione',
            okVariant: 'danger',
            okTitle: 'Elimina',
            cancelTitle: 'Annulla',
            centered: true,
          }).then(conferma => {
            if (!conferma) return
            // rimuovo la riga dalla grid solo dopo la conferma del backend
            useJwt.delete(deleteUrl).then(() => {
              console.log('Eliminazione avvenuta con successo')
              this.contributiFullData = this.contributiFullData.filter(x => x.id !== deletedElementId)
            }).catch(err => {
              console.log(err)
              this.makeToast('danger', 'Errore', 'Eliminazione del contributo non riuscita')
            })
          })
        } catch (err) {
          console.log(err)
          console.log('Occorre selezionare una riga della tabella')
          this.alertAShow()
        }
      }
    },

    // per alert
    alertACountDownChanged(alertADismissCountDown) {
      this.alertADismissCountDown = alertADismissCountDown
    },
    alertAShow() {
      this.alertADismissCountDown = this.alertADismissSecs
    },
    // per toast
    makeToast(variant = null, title = 'titolo', message = 'messaggio') {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
        autoHideDelay: 5000,
      })
    },
    noop() {
      console.log('premuto enter')
    },
  },
})

/* eslint-disable global-require */
</script>

<style lang="scss">
@import "~@syncfusion/ej2-base/styles/material.css";
@import "~@syncfusion/ej2-buttons/styles/material.css";
@import "~@syncfusion/ej2-vue-buttons/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/datepicker/material.css";
@import "~@syncfusion/ej2-dropdowns/styles/material.css";
@import "~@syncfusion/ej2-vue-popups/styles/material.css";
@import "~@syncfusion/ej2-vue-navigations/styles/material.css";
@import "~@syncfusion/ej2-inputs/styles/material.css";
@import "~@syncfusion/ej2-vue-layouts/styles/material.css";
@import "~@syncfusion/ej2-splitbuttons/styles/material.css";
@import "~@syncfusion/ej2-grids/styles/material.css";

.e-btn-icon.e-open-icon {
  background: url("~@/assets/images/svg/open2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-delete-icon {
  background: url("~@/assets/images/svg/garbage-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-download-icon {
  background: url("~@/assets/images/svg/download2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-search-icon {
  background: url("~@/assets/images/svg/search-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-upload-icon {
  background: url("~@/assets/images/svg/upload-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-add-icon {
  background: url("~@/assets/images/svg/add2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

// seleziono il colore per evidenziare la riga selezionata
.e-grid td.e-active {
  background-color: #e5cbdd;
}
// per disabilitare la grid
.disablegrid {
  pointer-events: none;
  opacity: 0.4;
}

.wrapper {
  cursor: not-allowed;
}
</style>
